/**
 * Auth Feature Types and Constants
 */

// Auth modes/views
export const AUTH_MODES = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  OTP_VERIFY: 'otp_verify',
  PASSWORD_LOGIN: 'password_login',
  FORGOT_PASSWORD: 'forgot_password',
  RESET_PASSWORD: 'reset_password',
  SET_PASSWORD: 'set_password',
  REGISTRATION_FORM: 'registration_form',
};

// Input types
export const INPUT_TYPES = {
  MOBILE: 'mobile',
  EMAIL: 'email',
};

// OTP purposes
export const OTP_PURPOSE = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  FORGOT_PASSWORD: 'forgot_password',
};

// Validation patterns
export const VALIDATION_PATTERNS = {
  MOBILE: /^[6-9]\d{9}$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  OTP: /^\d{6}$/,
  NAME: /^[a-zA-Z\s]+$/,
  PASSWORD: {
    MIN_LENGTH: 8,
    SPECIAL_CHAR: /[!@#$%^&*(),.?":{}|<>]/,
    NUMBER: /\d/,
    UPPERCASE: /[A-Z]/,
  },
};

// Error messages
export const ERROR_MESSAGES = {
  REQUIRED_MOBILE: 'Please enter your mobile number',
  REQUIRED_EMAIL: 'Please enter your email',
  INVALID_MOBILE: 'Please enter a valid 10-digit mobile number',
  INVALID_MOBILE_START: 'Mobile number must start with 6, 7, 8, or 9',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_OTP: 'Please enter a valid 6-digit OTP',
  REQUIRED_OTP: 'Please enter the OTP',
  REQUIRED_PASSWORD: 'Please enter your password',
  PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters',
  PASSWORD_SPECIAL_CHAR: 'Password must include at least one special character',
  PASSWORD_NUMBER: 'Password must include at least one number',
  PASSWORD_UPPERCASE: 'Password must include at least one uppercase letter',
  PASSWORDS_MISMATCH: 'Passwords do not match',
  REQUIRED_FIRST_NAME: 'Please enter your first name',
  REQUIRED_LAST_NAME: 'Please enter your last name',
  INVALID_NAME: 'Name cannot contain numbers or special characters',
  REQUIRED_DOB: 'Please select your date of birth',
  REQUIRED_SALUTATION: 'Please select a salutation',
  GENERIC_ERROR: 'Something went wrong. Please try again.',
};

// Success messages
export const SUCCESS_MESSAGES = {
  OTP_SENT: 'OTP sent successfully',
  LOGIN_SUCCESS: 'Login successful',
  SIGNUP_SUCCESS: 'You are successfully registered!',
  PASSWORD_SET: 'Password set successfully',
  PASSWORD_RESET: 'Password reset successfully',
};

// Salutation options
export const SALUTATION_OPTIONS = [
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Ms', label: 'Ms' },
  { value: 'Dr', label: 'Dr' },
];
